export default ( 
    () => {
        
        // LOCAL:
        //return 'http://192.168.86.41:8081';

        // t4g large - NEW INSTANCE - IP: 3.14.139.24, EIP: 3.14.139.24
        //return 'https://ec2-3-14-139-24.us-east-2.compute.amazonaws.com'

        // HTTP-DOMAIN:
        //return 'http://api.vedicastrochart.com';

        // HTTPS-DOMAIN:
        return 'https://api.vedicastrochart.com';
    }
);